module.exports = __webpack_public_path__ + "img/ben T 1.c9f21140.jpg";